import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedZorroModule } from '../../shared-zorro.module';
import { RouterModule, Router, ActivatedRoute } from '@angular/router';
import { UserService } from '../../service/user.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-report',
  standalone: true,
  imports: [CommonModule, SharedZorroModule, RouterModule],
  templateUrl: './report.component.html',
  styleUrl: './report.component.less',
})
export class ReportComponent {
  caseId: string = '';
  fileUrl: SafeResourceUrl = '';
  constructor(private route: ActivatedRoute, private userService: UserService, private sanitizer: DomSanitizer) {
    this.route.params.subscribe((params) => {
      this.caseId = params['id']; // 获取路由参数中的 id
    });
  }

  ngOnInit() {
    this.getPdfReport({ id: this.caseId });
  }

  //获取PDF二进制文件流
  getPdfReport(item: any) {
    this.userService.downloadReport(item.id).subscribe((res: any) => {
      const blob = new Blob([res], { type: 'application/pdf' }); // 根据文件类型调整 MIME 类型
      let fileUrl = URL.createObjectURL(blob); // 创建文件 URL
      // 定义文件名
      this.fileUrl = this.sanitizer.bypassSecurityTrustResourceUrl(fileUrl); // 信任 URL
    });
  }
}
